import api from './api';
import API_ROUTES from './apiRoutes';

const R = API_ROUTES.SUPER_ADMIN;

const commitmentScannerService = {
  getStatus: async () => (await api.get(R.COMMITMENT_SCANNER_STATUS)).data,
  listScans: async () => (await api.get(R.COMMITMENT_SCANS)).data,
  getScan: async (id) => (await api.get(R.COMMITMENT_SCAN(id))).data,

  uploadScan: async (file, name) => {
    const formData = new FormData();
    formData.append('file', file);
    if (name) formData.append('name', name);
    const response = await api.post(R.COMMITMENT_SCAN_UPLOAD, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 120000,
    });
    return response.data;
  },
  databaseScan: async ({ includeCommitted = false } = {}) =>
    (await api.post(R.COMMITMENT_SCAN_DATABASE, { includeCommitted }, { timeout: 120000 })).data,

  cancelScan: async (id) => (await api.post(R.COMMITMENT_SCAN_CANCEL(id))).data,
  applyNew: async (id) => (await api.post(R.COMMITMENT_SCAN_APPLY_NEW(id), {}, { timeout: 120000 })).data,
  applyResult: async (id, body = {}) => (await api.post(R.COMMITMENT_RESULT_APPLY(id), body)).data,
  dismissResult: async (id) => (await api.post(R.COMMITMENT_RESULT_DISMISS(id))).data,
  setResultPlayer: async (id, playerId) => (await api.patch(R.COMMITMENT_RESULT_PLAYER(id), { playerId })).data,
  searchPlayers: async (q) => (await api.get(R.COMMITMENT_SCANNER_PLAYERS, { params: { q } })).data,
};

export default commitmentScannerService;
